<template>
    <!-- 票台管理 － 售票信息 -->
    <div>
        <content-view class="ticketSaleInfo" v-show="$utils.renderWhen(this,'cashierStoreValueInfo')">
            <div slot="header">
                <a-form :form="form" layout="inline">
                    <a-form-item label="储值卡名称">
                        <a-input placeholder="请输入" v-decorator="['name']"></a-input>
                    </a-form-item>
                    <a-form-item class="wrap-header-button">
                        <a-button @click="search" class="mr8" type="primary">筛选</a-button>
                        <a-button @click="handleReset">重置</a-button>
                    </a-form-item>
                </a-form>
            </div>
            <div class="wrap-container-in">
                <a-tabs :defaultActiveKey="1" :animated="false" @change="onTabChange">
                    <a-tab-pane tab="绑定且展示至该票台" :key="1">
                    </a-tab-pane>
                    <a-tab-pane tab="绑定且不展示至该票台" :key="0">
                    </a-tab-pane>
                </a-tabs>
                <a-table
                    bordered
                    :dataSource="dataSource"
                    :columns="columns"
                    :pagination="pagination"
                    @change="changePage"
                    :rowKey="record => record.id"
                    :loading="loading"
                    >
                    <span slot="index" slot-scope="a, row, index">{{index+1}}</span>
                    <span slot="state" slot-scope="key">{{key ? '已展示' : '不展示'}}</span>
                    <span slot="action" slot-scope="a, row">
                        <a-popconfirm
                        v-if="getBtnByAuth('storeValueToShelf')"
                        :title="`确定将票台上的该门店票券${row.isShow ? '不展' : '展'}示至该票台吗?`"
                        @confirm="changeState(row.id)"
                        >
                            <a class="text-primary">{{row.isShow ? '不展' : '展'}}示至该票台</a>
                        </a-popconfirm>
                    </span>
                </a-table>
            </div>
        </content-view>
        <router-view></router-view>
    </div>
</template>

<script type="text/javascript">
    import { mapGetters } from "vuex";
    //  默认表头
    const columns = [
        {
            title: "序号",
            dataIndex: "index",
            scopedSlots: { customRender: "index" }
        },
        {
            title: "储值卡名称",
            dataIndex: "name"
        },
        {
            title: "销量",
            dataIndex: "sellNum"
        },
        {
            title: "售价",
            dataIndex: "price"
        },
        {
            title: "状态",
            dataIndex: "isShow",
            scopedSlots: { customRender: "state" }
        },
        {
            title: "操作",
            scopedSlots: { customRender: "action" }
        }]
    export default {
        name: "storeValueInfo",
        components: {},
        props: {},
        data() {
            return {
                columns,
                noTitleKey: 1,
                dataSource: [],
                pagination: {
                    showTotal: total => `共 ${total} 条数据`,
                    showQuickJumper: true,
                    showSizeChanger: true,
                    current: 1,
                    pageSize: 20,
                    total: 0,
                },
                form: null,
                loading: false
            };
        },
        computed: {
            ...mapGetters(["shopId"])
        },
        methods: {
            handleReset () {
                this.form.resetFields();
                this.search();
            },
            search() {
                this.pagination.current = 1;
                this.getList();
            },
            onTabChange(noTitleKey) {
                this.noTitleKey = noTitleKey;
                this.pagination.current = 1;
                this.getList();
            },
            // 表格分页器回调
            changePage(page) {
                this.pagination = page;
                this.getList();
            },

            // 获取储值商品列表
            getList() {
                if (this.loading) {
                    return false;
                }
                this.form.validateFields((err, values) => {
                    if (err) return;
                    this.loading = true;
                    this.$api.ticketDesk.cardInfoList({
                        body: {  
                            ...values, 
                            isShow: Boolean(this.noTitleKey),
                            counterId: this.$route.params.id,
                            pageNum: this.pagination.current,
                            pageSize: this.pagination.pageSize
                        }
                    }).then(res => {
                        this.loading = false;
                        this.pagination.total = res.total;
                        this.dataSource = res.list;
                    }).catch(err => {
                        this.loading = false;
                    });
                });
            },
            // 修改状态
            changeState(id) {
                if (this.loading) {
                    return false;
                }
                this.loading = true;
                this.$api.ticketDesk.cardInfoChange({
                    params: {
                        id: id
                    }
                }).then(data=>{
                    this.$message.success('操作成功');
                    this.loading = false;
                    this.getList();
                }).catch(err => {
                    this.loading = false;
                })
            },
        },
        created() {
            this.form = this.$form.createForm(this);
        },
        mounted() {
            this.getList();
        }
    };
</script>
<style lang="scss">
</style>